import { useState } from 'react';

const faqs = [
  { question: 'Which exam boards does GCSE Computing cover?', answer: 'We cover all four major UK Computer Science exam boards — AQA, OCR, Edexcel, and WJEC — for both GCSE and A Level. All revision materials are mapped directly to each board\'s official specification.' },
  { question: 'Is GCSE Computing free to use?', answer: 'Yes! Creating an account is completely free and gives you access to the full syllabus browser, topic summaries, and upcoming exam dates. Premium resources such as past paper walkthroughs and detailed revision guides are available with a free account.' },
  { question: 'How is the content structured?', answer: 'Content is organised by exam board and topic, following the official specification order. Each topic includes a concise summary, key terms, worked examples, and links to relevant past paper questions so you can revise and practise in one place.' },
  { question: 'Can I track my revision progress?', answer: 'Absolutely. Once you\'re logged in, you can mark topics as complete, track your progress through each unit, and see an overview of how much of the syllabus you\'ve covered — helping you focus on the areas that need the most attention.' },
  { question: 'Are the resources suitable for both GCSE and A Level?', answer: 'Yes. We have dedicated content for both GCSE and A Level Computer Science. The difficulty and depth of material is clearly labelled so you always know you\'re revising the right content for your qualification level.' },
  { question: 'How often is the content updated?', answer: 'Our team reviews and updates all content at the start of each academic year to reflect any specification changes from the exam boards. We also add new past paper questions and resources throughout the year as they become available.' },
];

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const toggle = (i: number) => setOpenIndex(openIndex === i ? null : i);

  return (
    <section className="py-20 bg-slate-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-14">
          <span className="text-xs font-semibold uppercase tracking-widest text-emerald-700 mb-3 block">Got Questions?</span>
          <h2 className="text-3xl md:text-4xl font-extrabold text-slate-900 mb-4" style={{ fontFamily: "'Inter', sans-serif" }}>
            Frequently Asked Questions
          </h2>
          <p className="text-slate-500 text-base max-w-xl mx-auto">
            Everything you need to know about GCSE Computing. Can't find an answer?{' '}
            <a href="/contact" className="text-emerald-700 hover:underline font-medium">Get in touch</a>.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
          {faqs.map((faq, i) => {
            const isOpen = openIndex === i;
            return (
              <div key={i} className={`bg-white rounded-xl border transition-all duration-200 overflow-hidden ${isOpen ? 'border-emerald-200' : 'border-slate-200 hover:border-slate-300'}`}>
                <button onClick={() => toggle(i)} className="w-full flex items-center justify-between gap-4 px-6 py-5 text-left cursor-pointer">
                  <span className={`text-sm font-semibold leading-snug transition-colors ${isOpen ? 'text-emerald-800' : 'text-slate-800'}`} style={{ fontFamily: "'Inter', sans-serif" }}>
                    {faq.question}
                  </span>
                  <div className={`w-7 h-7 flex-shrink-0 flex items-center justify-center rounded-full transition-all duration-200 ${isOpen ? 'bg-emerald-700 text-white' : 'bg-slate-100 text-slate-500'}`}>
                    <i className={`ri-${isOpen ? 'subtract' : 'add'}-line text-sm`}></i>
                  </div>
                </button>
                <div className={`transition-all duration-300 ease-in-out ${isOpen ? 'max-h-60 opacity-100' : 'max-h-0 opacity-0'} overflow-hidden`}>
                  <p className="px-6 pb-5 text-slate-500 text-sm leading-relaxed">{faq.answer}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
